const Core = {
  /**
   *
   * @returns {Core}
   * @private
   */
  __construct: function () {
    this.init();
    return this;
  },

  init: function () {
    console.log('Deze site wordt onderhouden door LoungeRoom / https://loungeroom.nl' +
        '\n' +
        'Heb je een bug of vulnerability gevonden? Mail: info@loungeroom.nl' +
        '\n' +
        'Thanks!'
    );

    $(window).on('load', function () {
      Core.slick();
      Core.hoverMenu();
      Core.jump();
      Core.scrollButton();
    });

    /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function () {
      Core.mobileSlick();
    });


  },

  hoverTimeout: null,
  language: "nl",
  standalone: false,
  isBusy: false,
  xhr: false,
  msgChannel: null,
  target: "#dynamicModal",

  startLoader: function () {
    Core.isBusy = true;
    $("body").addClass("loading loading-anim");
  },

  stopLoader: function () {
    Core.isBusy = false;
    window.setTimeout(function () {
      $("body").removeClass("loading-anim");
    }, 300);
    window.setTimeout(function () {
      $("body").removeClass("loading");
    }, 500);
  },

  toastError: function (message) {
    if ($("#errorNotice").length == 1) {
      $("#errorNotice").remove();
    }

    let $needsContainer = true;
    if (message.indexOf("alert-") !== -1) {
      $needsContainer = false;
    }

    $("body").prepend(
        '    <div id="errorNotice">' +
        ($needsContainer
            ? '<div class="alert alert-info"><!--<i class="fa fa-warning"></i>-->'
            : "") +
        "       " +
        message +
        '       <a href="#" class="close"></a>' +
        ($needsContainer ? "</div>" : "") +
        "    </div>"
    );
  },

  uniqid: function (prefix = "", random = false) {
    const sec = Date.now() * 1000 + Math.random() * 1000;
    const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
    return `${prefix}${id}${random ? `.${Math.trunc(Math.random() * 100000000)}`:""}`;
  },

  removeToast: function () {
    $("#errorNotice").remove();
  },

  /**
   * Cancel all xhr requests
   */
  cancelRequests: function () {
    if (
        Core.xhr &&
        Core.xhr !== false &&
        Core.xhr.readystate !== 4
    ) {
      Core.xhr.abort();
    }
  },

  getArrayFromFormData: function (formData) {
    return Array.from(formData.entries(), ([key, prop]) => (
        {
          [key]: {
            "ContentLength":
                typeof prop === "string"
                    ? prop.length
                    : prop.size
          }
        }));
  },

  getFormDataFromArray: function (array) {
    let formData = new FormData();
    for (const [key, element] of Object.entries(array)) {
      if (element && typeof element === 'object') {
        let loopIndex = 0;
        for (const [subKey, subElement] of Object.entries(element)) {
          if (typeof subElement === 'object') {
            for (const [subsubKey, subsubElement] of Object.entries(subElement)) {
              formData.append(key + '[' + subKey + '][' + subsubKey + ']', subsubElement);
            }
          } else {
            formData.append(key + '[' + subKey + ']', subElement);
          }
          loopIndex++;
        }
      } else {
        if (typeof element === 'string' || typeof element === 'number' || typeof element === 'boolean') {
          formData.append(key, element);
        } else {
          formData.append(key, false);
        }
      }
    }

    return formData;

  },

  scrollButton: function () {
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 120) {
        $('#back-to-top').fadeIn(200);
      } else {
        $('#back-to-top').fadeOut(200);
      }
    });

    $('#back-to-top').on('click', function () {
      $('body,html').stop().animate({
        scrollTop: 0
      }, 400);
      return false;
    });
  },

  hoverMenu: function () {

    $('#mobileToggle').on('click', function (e) {
      e.preventDefault()
      $('#mobileMenu').toggleClass('hidden');
      $('#mobileToggle').toggleClass('menu--opened', !$('#mobileMenu').hasClass('hidden'))
    });

    // if not on mobile
    if (!$('.navbar-toggler').is(':visible')) {
      $(".dropdown").mouseenter(function () {
        if (Core.hoverTimeout) {
          window.clearTimeout(Core.hoverTimeout);
        }
        let dropdownMenu = $(this).children(".dropdown-menu");
        if (dropdownMenu.is(":visible")) {
          dropdownMenu.parent().addClass("open");
          dropdownMenu.addClass("show");
        }
      });
      $(".dropdown").mouseleave(function () {
        Core.hoverRemoveDelayed($(this));
      });
      $(".dropdown-menu").mouseenter(function () {
        if (Core.hoverTimeout) {
          window.clearTimeout(Core.hoverTimeout);
        }
      });
    }
  },

  hoverRemoveDelayed: function ($element) {
    if (Core.hoverTimeout) {
      window.clearTimeout(Core.hoverTimeout);
      Core.hoverTimeout = null;
    }
    if (!Core.hoverTimeout) {
      Core.hoverTimeout = window.setTimeout(function () {
        $element.closest(".dropdown").removeClass('open');
        $element.children(".dropdown-menu").removeClass("show");
      }, 500);
    }
  },

  slickOptions: function ($slider) {
    let breakpoint768 = {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: false
      }
    };
    let breakpoint1260 = {
      breakpoint: 1260,
      settings: {
        arrows: false,
        dots: false
      }
    };
    let sliderOptions = {
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 10000
    };

    if ($slider.data('disable-autoplay')) {
      sliderOptions.autoplay = false;
    }

    if ($slider.data('browse') || $slider.hasClass('arrows')) {
      sliderOptions.arrows = true;
    }

    if ($slider.data('dots') || $slider.hasClass('dots')) {
      sliderOptions.dots = true;
    }

    if ($slider.data('arrows-mobile')) {
      breakpoint768.settings.arrows = true;
      breakpoint1260.settings.arrows = true;
    }

    if ($slider.data('dots-mobile')) {
      breakpoint768.settings.dots = true;
    }

    if ($slider.data('multiple-xs')) {
      if ($slider.data('multiple-xs')) {
        breakpoint768.settings.slidesToShow = parseInt($slider.data('multiple-xs'));
      }
      if ($slider.data('multiple-md')) {
        breakpoint1260.settings.slidesToShow = parseInt($slider.data('multiple-md'));
      }
      if ($slider.data('multiple-lg')) {
        sliderOptions.slidesToShow = parseInt($slider.data('multiple-lg'));
      } else {
        sliderOptions.slidesToShow = 4;
      }

    } else if ($slider.data('multiple')) {
      if (typeof $slider.data('multiple') == 'number') {
        sliderOptions.slidesToShow = parseInt($slider.data('multiple'));
      } else {
        if ($slider.children().length > 0 && $slider.children().length >= 4) {
          sliderOptions.slidesToShow = 4;
        } else {
          sliderOptions.slidesToShow = $slider.children().length;
        }

        breakpoint768.settings.slidesToShow = 1;

        if ($slider.children().length > 0 && $slider.children().length >= 2) {
          breakpoint1260.settings.slidesToShow = 2;
        } else {
          breakpoint1260.settings.slidesToShow = $slider.children().length;
        }
      }
    }

    sliderOptions.responsive = [
      breakpoint768,
      breakpoint1260
    ];
    return sliderOptions;
  },

  mobileSlick: function () {
    $('.mobile-slider').each(function (i, slider) {
      let $slider = $(slider);
      let sliderOptions = {
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        mobileFirst: true,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
      };

      if ($slider.data('disable-autoplay')) {
        sliderOptions.autoplay = false;
      }

      if ($slider.data('browse') || $slider.hasClass('arrows')) {
        sliderOptions.arrows = true;
      }

      if ($slider.data('dots') || $slider.hasClass('dots')) {
        sliderOptions.dots = true;
      }

      $slider.on('afterChange', function (event, slick, currentSlide) {
        Core.slideApplyCurrent(slider, currentSlide);
      });

      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 768) {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      } else {
        if (!$slider.hasClass('slick-initialized')) {
          $(slider).slick(sliderOptions);
          Core.slideApplyCurrent(slider, 0);
        }
      }
    });

  },

  slick: function () {
    $('.simple-slider').each(function (i, slider) {
      let $slider = $(slider);
      let sliderOptions = Core.slickOptions($slider);

      $slider.on('afterChange', function (event, slick, currentSlide) {
        Core.slideApplyCurrent(slider, currentSlide);
      });

      $(slider).slick(sliderOptions);
      Core.slideApplyCurrent(slider, 0);
    });

    $('.slider-navigation').on('click', '[data-slide]', function (e) {
      e.preventDefault();
      let $slider = $('#' + $(this).closest('.slider-navigation').data('slider'));
      $slider.slick('slickGoTo', $(this).data('slide'));
      Core.scrollToElement($slider)
    });

    $(".slider-nav a.prev").on('click', function (e) {
      e.preventDefault();
      let element = $(this).closest('.slider__holder').find('.simple-slider').eq(0);
      element.slick('slickPrev');
    });
    $(".slider-nav a.next").on('click', function (e) {
      e.preventDefault();
      let element = $(this).closest('.slider__holder').find('.simple-slider').eq(0);
      element.slick('slickNext');
    });
  },

  scrollToElement: function ($element) {
    let scrollTop = $element.offset().top;
    if ($("body").css('padding-top')) {
      scrollTop = parseInt(scrollTop) - parseInt($("body").css('padding-top'));
    }
    Core.jumpTo(scrollTop);
  },

  jumpTo: function (positionY) {
    $('html,body').stop().animate({scrollTop: positionY}, 300, 'swing');
  },

  jump: function () {
    $("body").on('click', 'a.jump, a[data-jump]', function (e) {
      e.preventDefault();
      let scrollID = $(this).data('jump') ? $(this).data('jump') : $(this).attr('href');
      if (scrollID === '#top') {
        Core.jumpTo(0);
      } else if ($(scrollID).length === 1) {
        Core.scrollToElement($(scrollID));
      }
    });
  },

  slideApplyCurrent: function (slickElement, currentSlide) {
    if (!currentSlide) {
      let currentSlide = $(slickElement).slick('slickCurrentSlide');
    }

    let $navigator = $('.slider-navigation[data-slider="' + $(slickElement).attr('id') + '"]');
    if ($navigator) {
      $navigator.find('a').removeClass('active');
      $navigator.find('a').eq(currentSlide).addClass('active');
    }
  },


};

export default Core.__construct();
